
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import useWarehouseOrderService from '../../../app/services/hooks/useWarehouseOrderService';
import {
    defaultWarehouseOrderDataForm,
    defaultWarehouseOrderRateDataForm,
    WarehouseOrderDataForm,
    WarehouseOrderRatesDataForm
} from '../../../app/models/WarehouseOrder';
import DefaultCard from '../../../components/default/DefaultCard';
import LazyLoading from '../../../components/LazyLoading';
import DefaultCreatedModifiedUserForm from '../../../components/default/DefaultCreatedModifiedUserForm';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import { Tab, Tabs } from 'react-bootstrap';
import useQuoteInvoicingService from '../../../app/services/hooks/useQuoteInvoicingService';
import WarehouseOrderShowForm from '../components/forms/WarehouseOrderShowForm';
import { WarehouseQuoteDetail } from '../../../app/models/WareHouseQuoteDetail';
import WarehouseOrderItemsContainer from '../components/WarehouseOrderItemsContainer';
import WarehouseOrderStorageContainer from '../components/containers/WareHouseOrderStorageContainer';
import WarehouseOrderExpeditionContainer from '../components/containers/WareHouseOrderExpeditionContainer';
import WarehouseOrderExtraServiceContainer from '../components/containers/WareHouseOrderExtraServicesContainer';
import WarehouseOrderRatesContainer from '../components/containers/WareHouseOrderRatesContainer';
import WarehouseOrderInvoicingShowForm from '../components/forms/WarehouseOrderInvoicingForm';
import { WarehouseOrderInvoicingShowDataForm } from '../../../app/models/WarehouseOrderInvoicing';
import { toast } from 'react-toastify';
import useWarehouseOrderInvoicingService from '../../../app/services/hooks/useWarehouseOrderInvoicingService';
import useOrderService from '../../../app/services/hooks/useOrderService';

type RouterParams = {
    id: string;
};

const WarehouseOrderShow = () => {
    const { id } = useParams<RouterParams>();
    const location = useLocation();
    const isUnifiedMode = location.pathname.startsWith('/pedidos/');

    const [errorFields, setErrorFields] = useState<any>();
    const { showWarehouseOrder, fetchingShowWarehouseOrder } =
        useWarehouseOrderService();
    const { showUnifiedOrder, fetchingShowOrder } = useOrderService();
    const isLoadingShow = isUnifiedMode ? fetchingShowOrder : fetchingShowWarehouseOrder;
    const [quotes, setQuotes] = useState<WarehouseQuoteDetail[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);
    // const [transportationOrderInvoicingForm, setWarehouseOrderInvoicingInvoicingForm] = useState<WarehouseOrderInvoicingShowDataForm>({});
    const { 
        editWarehouseOrderInvoicing,
        getWarehouseOrderInvoicingByWarehouseOrder,
        fetchingWarehouseOrderInvoicingByWarehouseOrder,
    } = useWarehouseOrderInvoicingService();

    const [transportationOrderForm, setWarehouseOrderForm] =
        useState<WarehouseOrderDataForm>(defaultWarehouseOrderDataForm);
    const [orderId, setOrderId] = useState<number | undefined>(undefined);

    const [transportationOrderRatesForm, setWarehouseOrderRatesForm] =
        useState<WarehouseOrderRatesDataForm>(defaultWarehouseOrderRateDataForm);
    const [quoteInvoicingForm, setWarehouseOrderInvoicingForm] = useState<WarehouseOrderInvoicingShowDataForm>({});

    useEffect(() => {
        show(parseInt(id));
    }, [id]);
    const show = (id: number) => {
        const showFn = isUnifiedMode ? showUnifiedOrder : showWarehouseOrder;
        showFn(id, {
            onSuccess: (response: ServiceResponse) => {
                const orderData = response.data.warehouse_order || response.data.transportation_order;
                setWarehouseOrderForm(orderData);
                setWarehouseOrderRatesForm(orderData);
                setQuotes(response.data.quotes);
                setWarehouseOrderInvoicingForm(response.data.invoicing);
                if (response.data.order_id) setOrderId(response.data.order_id);
            }
        });
    };

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Pedidos',
            url: '/pedidos',
            isActive: false
        },
        {
            name: 'Ver pedido #' + id,
            url: (isUnifiedMode ? '/pedidos/' : '/warehouse-orders/') + id + '/show',
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Ver pedido #${id}`} breadcrumbs={breadcrumbs} />
               <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                    <Tab eventKey="general-data" title="Datos Generales">
            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                        {!isLoadingShow ? (
                            <>
                                <WarehouseOrderShowForm
                                    warehouseOrderDataForm={transportationOrderForm}
                                    quotes={quotes}
                                />
                                {/*<WarehouseOrderRatesShow*/}
                                {/*    transportationOrderRatesForm={transportationOrderRatesForm}*/}
                                {/*/>*/}
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </div>
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                            {!isLoadingShow ? (
                                <DefaultCreatedModifiedUserForm
                                    createdBy={transportationOrderForm.created_user}
                                    createdAt={transportationOrderForm.created_at}
                                    updatedBy={transportationOrderForm.last_modified_user}
                                    updatedAt={transportationOrderForm.updated_at}
                                    status={transportationOrderForm.status}
                                    // status={
                                    //     transportationOrderForm.status_selected
                                    //         ? transportationOrderForm.status_selected.name.toString()
                                    //         : ''
                                    // }
                                />
                            ) : (
                                <LazyLoading />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            </Tab>
            <Tab eventKey="storage" title="Almacenamiento">
                <WarehouseOrderStorageContainer warehouseOrderId={parseInt(id)} disableUpdate={true} isFormShow={true}  />
            </Tab>

            <Tab eventKey="expedition" title="Expedición">
                <WarehouseOrderExpeditionContainer warehouseOrderId={parseInt(id)} disableUpdate={true} isFormShow={true} />
            </Tab>


            <Tab eventKey="extras" title="Servicios Adicionales">
                <WarehouseOrderExtraServiceContainer warehouseOrderId={parseInt(id)} disableUpdate={true} isFormShow={true} />
            </Tab>
            <Tab eventKey="invoicing" title="Facturación">
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">Facturación</div>
 
                        {!fetchingWarehouseOrderInvoicingByWarehouseOrder ? (
                            <>
                                <WarehouseOrderInvoicingShowForm
                                    warehouseOrderInvoicingDataForm={quoteInvoicingForm}
                                />
                                    </>
                                ) : (
                                    <LazyLoading />
                                )}
                        </DefaultCard>
            </Tab>
                <Tab eventKey="rates" title="Tarifas del servicio">
                    <WarehouseOrderRatesContainer warehouseOrderId={parseInt(id)} disableUpdate={true} isFormShow={true} />
                </Tab>
            </Tabs>

            <WarehouseOrderItemsContainer
                warehouseOrderId={parseInt(id)}
                orderId={orderId}
                canBeEdited={false}
                currencyId={transportationOrderForm.currency_id}
                isShow={true}
                warehouseOrderForm={transportationOrderForm}
                setWarehouseOrderForm={setWarehouseOrderForm}
            />
        </>
    );
};

export default WarehouseOrderShow;
